module.exports = __webpack_public_path__ + "img/1.5a58d736.jpg";